import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { EventsProvider } from '../../providers/events/events.provider';
import { EventPage } from '../event/event';

/**
 * Generated class for the CategorieResultPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-categorie-result',
  templateUrl: 'categorie-result.html',
})
export class CategorieResultPage {
  categorie:any;
  events:any;
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private eventsProvider: EventsProvider) {
    this.categorie = this.navParams.get('categorie');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CategorieResultPage');
    this.refresh();
  }


  goToEvent(event){
    this.navCtrl.push(EventPage, {event:event});
  }

  async refresh(){
    console.log("refresh",this.categorie.id);
    this.events = await this.eventsProvider.getEventsByCategorie(this.categorie.id);
    // console.log("this.events",this.events);
  }
}



// WEBPACK FOOTER //
// ./src/pages/categorie-result/categorie-result.ts